import { NativeEvent } from '../NativeEvent';

export interface BiometricEnrollPayload {
  /** Identificador do usuário (email ou CPF), como digitado no campo de login. */
  login: string;
  /** Senha em texto claro — será cifrada pelo Android Keystore no SecureStore. */
  password: string;
}

export class BiometricEnrollEvent extends NativeEvent<
  'biometricEnroll',
  BiometricEnrollPayload
> {
  readonly type = 'biometricEnroll';
  readonly payload: BiometricEnrollPayload;

  constructor(payload: BiometricEnrollPayload) {
    super();
    this.payload = payload;
  }

  protected override validate(): void {
    if (!this.payload.login) {
      throw new Error('BiometricEnrollEvent: login é obrigatório');
    }
    if (!this.payload.password) {
      throw new Error('BiometricEnrollEvent: password é obrigatório');
    }
  }
}
